import React from 'react';
import { SAMPLE_LOAD } from './samples';

const StopCard = ({ title, stop, variant }) => (
  <div className={`dp-stop-card dp-stop-card--${variant}`}>
    <div className="dp-stop-card__head">
      <span className={`dp-badge dp-badge--${variant}`}>{title}</span>
      {stop.appointment_date ? (
        <span className="dp-stop-card__appt">
          {stop.appointment_date}
          {stop.appointment_window ? ` · ${stop.appointment_window}` : ''}
        </span>
      ) : null}
    </div>
    <div className="dp-stop-card__name">{stop.company_name}</div>
    <div className="dp-stop-card__addr">
      {stop.address}
      <br />
      {stop.city}, {stop.state} {stop.zip_code}
    </div>
  </div>
);

const FreightImportReviewPreview = () => {
  const { deliveries } = SAMPLE_LOAD;

  return (
    <div className="dp-page">
      <div className="dp-stepper">
        <span className="dp-stepper__step dp-stepper__step--done">Upload</span>
        <span className="dp-stepper__line" />
        <span className="dp-stepper__step dp-stepper__step--active">Review</span>
        <span className="dp-stepper__line" />
        <span className="dp-stepper__step">Complete</span>
      </div>

      <header className="dp-page-header">
        <div>
          <p className="dp-eyebrow">Rate confirmation import</p>
          <h1 className="dp-title">Review parsed load</h1>
          <p className="dp-lead">
            Steamboat Transportation Group · PDF parsed successfully
          </p>
        </div>
        <div className="dp-header-actions">
          <span className="dp-badge dp-badge--success">Parser matched</span>
        </div>
      </header>

      <div className="dp-metrics">
        <div className="dp-metric">
          <span className="dp-metric__label">PO#</span>
          <span className="dp-metric__value">{SAMPLE_LOAD.po_number}</span>
        </div>
        <div className="dp-metric">
          <span className="dp-metric__label">Pickup</span>
          <span className="dp-metric__value">{SAMPLE_LOAD.pickup_date}</span>
        </div>
        <div className="dp-metric">
          <span className="dp-metric__label">Delivery</span>
          <span className="dp-metric__value">{SAMPLE_LOAD.delivery_date}</span>
        </div>
        <div className="dp-metric">
          <span className="dp-metric__label">Weight</span>
          <span className="dp-metric__value">{SAMPLE_LOAD.weight_lbs.toLocaleString()} lb</span>
        </div>
        <div className="dp-metric">
          <span className="dp-metric__label">Equipment</span>
          <span className="dp-metric__value">{SAMPLE_LOAD.trailer_size_ft} ft box</span>
        </div>
        <div className="dp-metric">
          <span className="dp-metric__label">Rate</span>
          <span className="dp-metric__value">${SAMPLE_LOAD.rate_amount.toLocaleString()}</span>
        </div>
      </div>

      <div className="dp-split">
        <section className="dp-panel">
          <h2 className="dp-panel__title">Stops from PDF</h2>
          <StopCard title="Pickup" stop={SAMPLE_LOAD.pickup} variant="pickup" />
          {deliveries.map((d, i) => (
            <StopCard key={i} title={`Delivery ${i + 1}`} stop={d} variant="delivery" />
          ))}
          <div className="dp-callout">
            <strong>Commodity</strong>
            <span>{SAMPLE_LOAD.commodity}</span>
          </div>
        </section>

        <section className="dp-panel">
          <h2 className="dp-panel__title">Match & assign</h2>
          <div className="dp-field">
            <label>Freight number</label>
            <input readOnly value={SAMPLE_LOAD.freight_number} className="dp-input" />
          </div>
          <div className="dp-field">
            <label>Shipper (pickup)</label>
            <select className="dp-input" defaultValue="1">
              <option value="1">{SAMPLE_LOAD.assignments.shipper}</option>
            </select>
          </div>
          <div className="dp-field">
            <label>Consignee — delivery 1</label>
            <select className="dp-input" defaultValue="1">
              <option value="1">{SAMPLE_LOAD.assignments.consignee}</option>
            </select>
          </div>
          <div className="dp-field-row">
            <div className="dp-field">
              <label>Carrier</label>
              <select className="dp-input" defaultValue="1">
                <option value="1">{SAMPLE_LOAD.assignments.carrier}</option>
              </select>
            </div>
            <div className="dp-field">
              <label>Driver</label>
              <select className="dp-input" defaultValue="1">
                <option value="1">{SAMPLE_LOAD.assignments.driver}</option>
              </select>
            </div>
          </div>
          <div className="dp-field">
            <label>Truck</label>
            <select className="dp-input" defaultValue="1">
              <option value="1">{SAMPLE_LOAD.assignments.truck}</option>
            </select>
          </div>

          <h3 className="dp-panel__subtitle">Manifests & route</h3>
          <label className="dp-check">
            <input type="checkbox" defaultChecked readOnly />
            Create one manifest per delivery stop
          </label>
          <label className="dp-check">
            <input type="checkbox" defaultChecked readOnly />
            Create route plan draft and add stops
          </label>
          <div className="dp-field">
            <label>Depot</label>
            <select className="dp-input" defaultValue="1">
              <option value="1">{SAMPLE_LOAD.assignments.depot}</option>
            </select>
          </div>
        </section>
      </div>

      <div className="dp-action-bar">
        <button type="button" className="dp-btn dp-btn--ghost">
          Back
        </button>
        <button type="button" className="dp-btn dp-btn--primary">
          Create freight & stops
        </button>
      </div>
    </div>
  );
};

export default FreightImportReviewPreview;
